import {
  LaunchStatusEvent,
  InputEmitter,
  StreamerStatus,
} from "@pureweb/platform-sdk";

import {
  useStreamer,
  IdleTimeout,
  VideoStream,
  System,
} from "@pureweb/platform-sdk-react";

import React, { useRef } from "react";
import { FullScreen, useFullScreenHandle } from "react-full-screen";
import { Button, Icon } from "semantic-ui-react";
import useAsyncEffect from "use-async-effect";
import { ethers } from "ethers";

// import "./styles.css";
import clientConfig from "../../client";

// const [streamerStatus, emitter, videoStream, audioStream, messageSubject] = useStreamer(signallingConnection, streamerOptions);
// https://opensea.io/assets/ethereum/0x219b2276a95ded887d1281c0841af4161c4bb415/99
// https://opensea.io/blog/announcements/announcing-embeddable-nfts/

import LoadingView from "../../components/LoadingView";
import OpenseaEmbed from "../../components/OpenseaEmbed";
import useWindowSize from "../../hooks/useWindowSize";

interface ViewProps {
  LaunchRequestStatus: LaunchStatusEvent;
  StreamerStatus: StreamerStatus;
  VideoStream: MediaStream;
  InputEmitter: InputEmitter;
  UseNativeTouchEvents: boolean;
  UsePointerLock: boolean;
  PointerLockRelease: boolean;
  isOpenseaEmbed: boolean;
}

const EmbeddedView: React.FC<ViewProps> = (props: ViewProps) => {
  // console.log("EmbeddedView props", props);
  const videoRef = useRef<HTMLVideoElement>(null);
  const handle = useFullScreenHandle();
  // Fullscreen API presently supported on iPad, but not iPhone or iPod
  const isIPhone =
    System.Browser().os === "iOS" &&
    !window.navigator.userAgent.includes("iPad");
  const windowSize = useWindowSize();

  const isHidden =
    isIPhone ||
    handle.active ||
    props.StreamerStatus !== StreamerStatus.Connected;

  const isLandscapeIphone =
    isIPhone && windowSize.width && windowSize.width > 600;
  return (
    <div
      style={{
        maxHeight: "200px",
        maxWidth: isLandscapeIphone ? "75%" : "100%",
      }}
    >
      <FullScreen handle={handle}>
        <IdleTimeout
          Status={props.StreamerStatus}
          WarningThreshold={300}
          ExitThreshold={120}
          WarningCallback={handle.exit}
          ExitCallback={() => window.location.reload()} // TODO: How to 'close' a contribution?
        />
        <LoadingView
          LaunchRequestStatus={props.LaunchRequestStatus}
          StreamerStatus={props.StreamerStatus}
        />
        <VideoStream
          VideoRef={videoRef}
          Emitter={props.InputEmitter}
          Stream={props.VideoStream}
          UseNativeTouchEvents={props.UseNativeTouchEvents}
          UsePointerLock={props.UsePointerLock}
          PointerLockRelease={props.PointerLockRelease}
        />
        <Button
          onClick={handle.enter}
          style={{ position: "absolute", bottom: 10, left: 10 }}
          className={isHidden ? "hidden" : ""}
        >
          <Icon name="expand" />
        </Button>
        {/* <Button
          onClick={() => sendMessageToGame("SetAuthorization:bool:true")}
          style={{ position: "absolute", top: 50, right: 20 }}
        >
          Send Message to Game TRUE
        </Button>
        <Button
          onClick={() => sendMessageToGame("SetAuthorization:bool:false")}
          style={{ position: "absolute", top: 90, right: 20 }}
        >
          Send Message to Game FALSE
        </Button>
        <Button
          onClick={() => sendMessageToGame("Reset:bool:false")}
          style={{ position: "absolute", top: 120, right: 20 }}
        >
          RESET:false
        </Button> */}
        {/* <Button
          onClick={() => sendMessageToGame("SetMobile:bool:true")}
          style={{ position: "absolute", top: 120, right: 20 }}
        >
          SetMobile:bool:true
        </Button>
        <Button
          onClick={() => sendMessageToGame("SetMobile:bool:false")}
          style={{ position: "absolute", top: 160, right: 20 }}
        >
          SetMobile:bool:false
        </Button> */}
        {/* <InGameLocationNav sendMessageToGame={sendMessageToGame} /> */}
        {props.isOpenseaEmbed && (
          <OpenseaEmbed
            contractAddress="0x219b2276a95ded887d1281c0841af4161c4bb415"
            nftId="99"
          />
        )}
        {/* <ChatEngine /> */}
      </FullScreen>
    </div>
  );
};

export default EmbeddedView;
